import type { AnyFunction } from "@otto-ec/assets-core-utils/misc";
import { UnsupportedError } from "../runtime/error/errors";

/**
 *
 */
export const createClientOnlyError = () => (): never => {
  throw new UnsupportedError("This function can not be used in the server context");
};

/**
 *
 *
 *
 *
 *
 */
export const clientOnly = <F extends AnyFunction>(func: F): F =>
  import.meta.env.SSR ? (createClientOnlyError as F) : func;

export const createServerOnlyError = () => (): never => {
  throw new UnsupportedError("This function can not be used in the client context");
};
